export default __webpack_public_path__ + "static/media/python coding group button@2x.ef1b75a1.png";